import {useEffect, useState} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import {PageOverlayer} from '../../../components/PageOverlayer'
import {useFormik} from 'formik'
import Swal from 'sweetalert2'
import {
  createPersonChangeStatusInitValues,
  TPersonChangeStatusForm,
  TPersonChangeStatusRequest,
} from '../../../coreGlobal/models/person'
import {personChangeStatusSchema} from '../utils/createdPersonChangeStatus'
import useAuthorization from '../../../hooks/useAuthorization'
import {useParams} from 'react-router-dom'
import {changeStatusModal} from '../list/core/_requests'

interface IPersonModalInfo {
  lastClientHistory: any
  close: any
}

const StatusModal = ({lastClientHistory, close}: IPersonModalInfo) => {
  const isAuthorizedToShow = useAuthorization('persons.change_status')
  let {id} = useParams()
  const [loadingPage, setLoadingPage] = useState(false)
  const [loading, setLoading] = useState(false)

  const closeModal = () => {
    close()
  }

  const formik = useFormik<TPersonChangeStatusForm>({
    initialValues: createPersonChangeStatusInitValues,
    validationSchema: personChangeStatusSchema,
    validateOnMount: true,
    onSubmit: async (values) => {
      submit(values)
    },
  })

  useEffect(() => {
    formik.setFieldValue(
      'status',
      lastClientHistory?.status?.id !== 2 ? lastClientHistory?.status?.id : null
    )
  }, [lastClientHistory])

  const submit = async (req: TPersonChangeStatusRequest) => {
    await Swal.fire({
      title: 'Deseja alterar o status do cliente?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
        cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        try {
          await changeStatusModal(String(id), req)

          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Salvo com sucesso',
            showConfirmButton: false,
            timer: 1500,
          })
          window.location.reload()
        } catch (error: any) {
          await Swal.fire({
            icon: 'warning',
            title: 'Oops...',
            text: error?.response?.data?.message,
            showConfirmButton: true,
            customClass: {
              confirmButton: 'btn btn-danger',
              cancelButton: 'btn btn-secondary',
            },
          })
        } finally {
          setLoading(false)
        }
      }
    })
  }

  return (
    <>
      {loadingPage ? (
        <PageOverlayer />
      ) : (
        <>
          <div
            className='modal fade show d-block'
            id='kt_modal_edit_user'
            role='dialog'
            tabIndex={-1}
            aria-modal='true'
          >
            <div className='modal-dialog modal-dialog-centered mw-1000px'>
              <div className='modal-content'>
                <form onSubmit={formik.handleSubmit} noValidate className='form'>
                  <div className='modal-header'>
                    <h2 className='fw-bolder' style={{color: '#D31145'}}>
                      Status do cliente
                    </h2>
                    <div
                      className='btn btn-icon btn-sm btn-active-icon-primary'
                      data-kt-users-modal-action='close'
                      onClick={closeModal}
                      style={{cursor: 'pointer'}}
                    >
                      <KTIcon iconName='cross' className='fs-1' />
                    </div>
                  </div>
                  <div className='modal-body scroll-y'>
                    <div className='col-12 mt-5'>
                      <div className='col-6'>
                        <label htmlFor='' className='required'>
                          <b>Status cliente</b>
                        </label>
                      </div>
                      <select
                        name='status_medical_record'
                        className='form-select'
                        value={Number(formik.values.status)}
                        onChange={(e) => {
                          const value = Number(e.target.value) || null
                          formik.setFieldValue('status', value)
                        }}
                        disabled={!isAuthorizedToShow}
                      >
                        {lastClientHistory?.status.id !== 3 &&
                          lastClientHistory?.status.id !== 1 && <option value=''></option>}
                        {lastClientHistory?.status.id !== 2 && <option value={1}>Ativo</option>}
                        <option value={3}>Outros</option>
                      </select>
                    </div>
                    {formik.errors.status && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.status}</div>
                      </div>
                    )}
                    <div className='col-12 mt-4'>
                      <div className='col-6'>
                        <label htmlFor='' className={formik.values.status !== 3 ? '' : 'required'}>
                          <b>Observação</b>
                        </label>
                      </div>
                      <div className='col-12'>
                        <input
                          type='text'
                          className='form-control'
                          value={formik.values.observation}
                          onChange={(e) => {
                            const value = e.target.value
                            formik.setFieldValue('observation', value)
                          }}
                        />
                      </div>
                      {formik.errors.observation && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.observation}</div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='card-footer d-flex justify-content-end py-6 px-9'>
                    <button
                      type='reset'
                      className='btn btn-secondary me-2'
                      onClick={() => closeModal()}
                      disabled={formik.isSubmitting || loading}
                    >
                      Cancelar
                    </button>
                    {isAuthorizedToShow && (
                      <button
                        type='submit'
                        className='btn btn-danger'
                        disabled={loading || !formik.isValid}
                      >
                        {!loading && 'Salvar'}
                        {loading && (
                          <span className='indicator-progress' style={{display: 'block'}}>
                            Salvando...{' '}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className='modal-backdrop fade show'></div>
        </>
      )}
    </>
  )
}

export {StatusModal}
